import styles from "./Segmented.module.scss";

// FE-SH Segmented control (Segmented — Person|Company, Show|Festival, L/C/R). A radiogroup of pills; the
// selected pill carries data-selected for the token styling. Local to the Ad Creator (the CreateOrgScreen stand-in
// precedent); promote to @cntrl/ui when the shared branding layer lands.
export interface SegmentedOption<T extends string> {
  value: T;
  label: string;
  hint?: string;
}

export function Segmented<T extends string>({
  options,
  value,
  onChange,
  ariaLabel,
}: {
  options: SegmentedOption<T>[];
  value: T;
  onChange: (value: T) => void;
  ariaLabel: string;
}) {
  return (
    <div role="radiogroup" aria-label={ariaLabel} className={styles.group}>
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          role="radio"
          aria-checked={o.value === value}
          data-selected={o.value === value || undefined}
          className={styles.pill}
          onClick={() => onChange(o.value)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
